module.exports = __webpack_public_path__ + "static/media/undraw_city_driver_jh2h.2e8883f3.svg";